import * as yup from 'yup'
import { requiredTextFieldValidationSchema, textFieldValidationSchema } from './singleFieldsValidationSchemas'

const validationSchema = yup.object().shape({
  description: textFieldValidationSchema('description', 1000),
  name: requiredTextFieldValidationSchema('name', 100),
})

export default validationSchema
